export default {
  methods: {
    GetNews: function (page = null, callback = null, errorCallback = null) {
      this.__getNews("News", page, callback, errorCallback);
    },

    GetHeadlines: function (page = null, callback = null, errorCallback = null) {
      this.__getNews("Headlines", page, callback, errorCallback);
    },

    __getNews: function (
      section,
      page = null,
      callback = null,
      errorCallback = null
    ) {


      var url =
        section == "News"
          ? `https://ma7moud.net/News/GetNews`
          : `https://ma7moud.net/News/GetHeadlines`;

      if (page) {
        url += `?page=${page}`;
      }

      // if i'm in development mode i will change the port
      // because vue and node backend both operate in different ports
      if (process.env.NODE_ENV == "development") {
        url = url.replace(":8081", ":8080");
      }

      this.$http.get(url).then(
        (response) => {
          if (response.status == 200) {
            if (callback) return callback(response);
          }
        },
        (error) => {
          if (errorCallback) return errorCallback();
          console.error(error);
        }
      );
    },
  },
};
